<template>
  <div class="container">
<!--    <div>{{original}}</div>-->
<!--    <div>{{datosRegistroLugar}}</div>-->
    <div class="row">
      <div class="col-4">
        <div class="btn-group" role="group" style="width: 100%">
          <span class="text" style="margin: auto;">Cliente:</span>
          <v-select :options="optionsCliente" v-model="datosRegistroLugar.id_cliente"
                    label="cliente"
                    :reduce="it => it.id"
                    class="m-4" placeholder="--Selecciona--"
                    style="width: 100%"
          />
        </div>
      </div>
      <div class="col-4">
        <div class="btn-group" role="group" style="width: 100%">
          <span class="text" style="margin: auto;">Sucursal:</span>
          <v-select :options="optionsSucursal" v-model="datosRegistroLugar.id_sucursal"
                    label="nombre_sucursal"
                    :reduce="it => it.id"
                    class="m-4" placeholder="--Selecciona--"
                    style="width: 100%"
          />
        </div>
      </div>
      <div class="col-4">
        <div class="btn-group" role="group" style="width: 100%">
          <span class="text" style="margin: auto;">Área:</span>
<!--          <div>A: {{optionsAreas}}</div>-->
<!--          <div>B: {{datosRegistroLugar.ids_turno_area_sucursal}}</div>-->
          <v-select :options="optionsAreas" v-model="datosRegistroLugar.ids_turno_area_sucursal"
                    label="texto"
                    :reduce="it => it.id"
                    class="m-4" placeholder="--Selecciona--"
                    style="width: 100%"
                    multiple
          />
        </div>
      </div>
      <div class="col-4">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" v-model="datosRegistroLugar.solo_supervisar">
          <label class="form-check-label">Solo Supervisar "Área de trabajo"</label>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import {inject} from "vue";
import {AreaSucursalService} from "@/services/AreaSucursalService";
import {SucursalService} from "@/services/SucursalService";

export default {
  components: {},
  inject: ['$axios', '$localStorageService'],
  setup() {
    return {
      srv_AreaSucursalService: new AreaSucursalService(inject('$axios')),
      srv_SucursalService: new SucursalService(inject('$axios')),
    }
  },
  props: {
    original: Object,
    optionsCliente: Array
  },
  data() {
    return {
      datosRegistroLugar: {
        id_cliente: null,
        id_sucursal: null,
        solo_supervisar: false,
        ids_turno_area_sucursal: [],
      },

      optionsSucursal: [],
      optionsAreas: [],
      cargaTotal: false
    }
  },
  async mounted() {
    if (this.original != null && this.original.ids_turno_area_sucursal != null) {
      this.datosRegistroLugar = this.original;
      await this.obtenerSucursales();
      await this.obtenerAreas();
      this.cargaTotal = true;
    }
  },
  watch: {
    async 'datosRegistroLugar.id_cliente'() {
      if (this.cargaTotal) {
        await this.obtenerSucursales();
        await this.obtenerAreas();
      }
    },
    async 'datosRegistroLugar.id_sucursal'() {
      if (this.cargaTotal) {
        await this.obtenerAreas();
      }
    },
    optionsSucursal() {
      if (this.cargaTotal && (this.optionsSucursal == null
          || !this.optionsSucursal.some(it => it.id === this.datosRegistroLugar.id_sucursal))) {
        this.datosRegistroLugar.id_sucursal = null;
        this.datosRegistroLugar.ids_turno_area_sucursal = [];
      }
    },
    optionsAreas() {
      if (this.cargaTotal && (this.optionsAreas == null
          || !this.optionsAreas.some(it => it.id === this.datosRegistroLugar.ids_turno_area_sucursal))) {
        this.datosRegistroLugar.ids_turno_area_sucursal = [];
      }
    }
  },
  methods: {
    async obtenerSucursales() {

      this.optionsSucursal = [];

      if (this.datosRegistroLugar == null || this.datosRegistroLugar.id_cliente == null) {
        return;
      }

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });


      await this.srv_SucursalService.obtener(
          {nombre_cliente: "" + this.datosRegistroLugar.id_cliente, registro_activo: true}
      ).then((response) => {
        this.optionsSucursal = response;
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },

    async obtenerAreas() {

      this.optionsAreas = [];

      if (this.datosRegistroLugar == null || this.datosRegistroLugar.id_sucursal == null) {
        return;
      }

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });


      await this.srv_AreaSucursalService.areaSucursalTurno(
          {id_sucursal: "" + this.datosRegistroLugar.id_sucursal}
      ).then((response) => {
        if (response != null) {
          // console.info(response)
          this.optionsAreas = response.map(it => {
            return {
              "id": it.id_turno_area_sucursal,
              "texto": it.nombre_area_sucursal + " - " + it.nombre_turno_area_sucursal
            }
          });
        }
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },

  },
}
</script>

<style scoped>
</style>